import { Component, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import _ from 'lodash';
import { ClientLoggerService } from '../../services/client-logger.service';
import { Farm, ParnellEnum } from '../../interfaces/mysynch.interfaces';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
    standalone: false,
    selector: 'admin-farm-management',
    templateUrl: '../app/pages/admin-farm-management/admin-farm-management.view.html',
    styleUrls: ['../app/pages/admin-farm-management/admin-farm-management.style.css']
    })
export class AdminFarmManagement implements OnInit , OnDestroy{

    private performanceContext: PerformanceContext | null = null;
    private updatePermissionCode:string = 'ADMIN_FARM_MANAGEMENT_UPDATE';
    private editFarmStateName: string = "FarmManagementMaint";
    private totalCows: number = 0;

    
    private farmStatuses:ParnellEnum|{} = {};
    private pendingValue:string	= ""
    private pendingText:string	= "";


    hasUpdatePermission: boolean = false;
    isMobile: boolean = false; 
    loading: boolean = true;
    _:any = _;

    farms: Farm[] = [];
    

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(ClientLoggerService) private log:ClientLoggerService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,){

    }

    ngOnInit(): void {
        this.MSF.ready(() => {
            this.isMobile = this.deviceDetector.isMobile();
            this.farmStatuses = _.reject(_.values(this.mySynchEnumSvc.getMySynchEnumerationItems("PersonRoleStatus")),(i:ParnellEnum) => {
                                    return i.name === 'PENDING';
                                });
            this.pendingValue = _.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'value');
            this.pendingText = _.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'text');
            
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming('Page:FarmManagementDashboard:Render');
            this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
            this.refresh().then(() => {
                this.loading = false;
                this.perfMetricSvc.markPageReady('Page:FarmManagementDashboard:Render', this.performanceContext);
            });

        });
    }
    ngOnDestroy(): void {
            this.performanceContext = null;
    }

    private refresh() {
        return new Promise<void>((resolve,reject) => {
            this.loading = true;
            
            this.totalCows = 0;
            this.farms = [];

            this.perfMetricSvc.startTiming('Page:FarmManagementDashboardGetAllFarms:Request');
            this.api.getAllFarms(this.performanceContext, (err:any,data: Farm[]) => {
                this.perfMetricSvc.endTiming("page",'Page:FarmManagementDashboardGetAllFarms:Request', this.performanceContext);
                if (err) {
                    this.log.error(this.MSF.notify.danger('unable to get farms: ' + err));
                    this.farms = [];

                    resolve();
                    return;
                }
                this.perfMetricSvc.startTiming('Page:FarmManagementDashboard:Build');

                this.farms = _.clone(data);
                this.farms = _.sortByOrder(this.farms,["name"]);

                this.perfMetricSvc.endTiming("page",'Page:FarmManagementDashboard:Build', this.performanceContext);
                resolve();
            });
        });
    }

    editFarm(farm: Farm) {
        this.MSF.loadPage(this.editFarmStateName, { farmId: farm.farmId });
    }

    addFarm() {
        this.MSF.loadPage(this.editFarmStateName);
    }
 
    
}